module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 't2x3pzpk',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
